import React from "react";
import { Row, Col, Breadcrumb } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

/**
 * PageTitle component
 */
const PageTitle = (props) => {
  const navigate = useNavigate();
  const { backButton, navigation } = props;

  return (
    <Row>
      <Col>
        <div className="page-title-box">
          <div className="page-title-right">
            <Breadcrumb className="m-0">
              <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                Home
              </Breadcrumb.Item>

              {(props.breadCrumbItems || []).map((item, index) => {
                const target =
                  item.path && item.path.startsWith("/")
                    ? item.path
                    : `/${item.path || ""}`;

                return item.active ? (
                  <Breadcrumb.Item active key={index}>
                    {item.label}
                  </Breadcrumb.Item>
                ) : (
                  <Breadcrumb.Item
                    key={index}
                    linkAs={Link}
                    linkProps={{ to: target }}
                  >
                    {item.label}
                  </Breadcrumb.Item>
                );
              })}
            </Breadcrumb>
          </div>
          <div className="d-flex align-items-center">
            {backButton && (
              <button
                type="button"
                className="btn btn-sm d-flex align-items-center gap-2 me-3"
                style={{
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  border: '1px solid #0dcaf0',
                  borderRadius: '6px',
                  padding: '6px 14px',
                  fontSize: '14px',
                  fontWeight: '500',
                  backgroundColor: 'transparent',
                  color: '#0dcaf0',
                  boxShadow: 'none',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#0dcaf0';
                  e.currentTarget.style.borderColor = '#0dcaf0';
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateX(-2px)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(13, 202, 240, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = '#0dcaf0';
                  e.currentTarget.style.color = '#0dcaf0';
                  e.currentTarget.style.transform = 'translateX(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                onMouseDown={(e) => {
                  e.currentTarget.style.transform = 'translateX(-1px) scale(0.98)';
                }}
                onMouseUp={(e) => {
                  e.currentTarget.style.transform = 'translateX(-2px)';
                }}
                onClick={() => {
                  if (navigation) {
                    navigate(navigation);
                  } else {
                    navigate(-1);
                  }
                }}
              >
                <i className="mdi mdi-arrow-left" style={{ fontSize: '18px' }}></i>
                <span>Back</span>
              </button>
            )}
            <h4 className={`page-title ${backButton ? 'flex-grow-1 text-center mb-0' : ''}`}>{props.title}</h4>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default PageTitle;
